(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('BrandLookup', BrandLookup);

  BrandLookup.$inject = ['$resource', 'API_URI'];

  function BrandLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/brands';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
